import { CustomerCreditCard } from './customer-credit-card';
import {cardBrands, cssBrands} from '../constants/cards';
import {FraudnetData} from "./fraudnet-data";

export class CustomerPaymentMethod {

  identifier: string;
  card: CustomerCreditCard;
  sameCard: boolean;
  paymentConditionIdentifier: string;
  fraudnetData: FraudnetData;
  isAdyen: boolean;
  nickname: string;
  defaultCard: boolean;
  accountPaymentDataId: string;
  saveCard: boolean;

  constructor(identifier: string, fraudnetData?: any) {
    this.identifier = identifier;
    this.card = new CustomerCreditCard();
    this.fraudnetData = new FraudnetData();

    if (fraudnetData) {
      this.fraudnetData = fraudnetData;
    }
  }


  getLastCreditCardvalues(): string {
    if (this.card && this.card.cardNumber) {
      // Se o numero do cartao veio sem espaços
      if (this.card.cardNumber.indexOf(' ') < 0) {
        return `**** ${this.card.cardNumber.slice(-4)}`
      } else {
        const splittedNumber = this.card.cardNumber.split(' ');
        return `**** ${splittedNumber[splittedNumber.length - 1]}`;
      }
    }
  }

  getCreditCardIcon(): string {
    if (this.card && this.card.brand) {
      return cssBrands[this.card.brand];
    }
  }
}
